export default class ProductMapperStruct {
    constructor({ key, dataSource, dataSourceValue, castAs, castAsValue }) {
        this.key = key || '',
        this.dataSource = dataSource || '',
        this.dataSourceValue = dataSourceValue || '',
        this.castAs = castAs || '',
        this.castAsValue = castAsValue || ''
    }
}